module.exports = __webpack_public_path__ + "img/addPage.072ba3f5.svg";